import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MarketDrivenShippingMigratedModalContent } from './MarketDrivenShippingMigratedModalContent';

interface MarketDrivenShippingMigratedInfoModalProps {
    id: string;
    modalRef: React.RefObject<HTMLElementTagNameMap['s-modal'] | null>;
    onGoToProviders: () => void;
}

// The "what's new" info modal shown right after confirming the migration. Always mounted (see the
// banner's comment on why) — its content is only rendered once actually opened.
export const MarketDrivenShippingMigratedInfoModal: React.FC<MarketDrivenShippingMigratedInfoModalProps> = ({
    id,
    modalRef,
    onGoToProviders,
}) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    return (
        <s-modal
            ref={modalRef}
            id={id}
            size="large"
            heading={t('MARKET_DRIVEN_SHIPPING_MIGRATED_BANNER.MODAL.TITLE')}
            onShow={() => setIsOpen(true)}
            onHide={() => setIsOpen(false)}
        >
            {isOpen && <MarketDrivenShippingMigratedModalContent />}
            <s-button slot="primary-action" commandFor={id} command="--hide">
                {t('MARKET_DRIVEN_SHIPPING_MIGRATED_BANNER.MODAL.CONFIRM_BUTTON')}
            </s-button>
        </s-modal>
    );
};

export default MarketDrivenShippingMigratedInfoModal;
